import React, { Suspense, useMemo } from 'react';
import {
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import { CContainer, CFade } from '@coreui/react';
import { useSelector } from 'react-redux';
import Loading from '../../common/components/loading';

// routes config
import { routes, clientRoutes } from '../config/routes';

const Content = () => {
  const isAdmin = useSelector((state) => state.auth.isAdmin);

  const currentRoutes = useMemo(() => (isAdmin ? routes : clientRoutes), [isAdmin]);

  return (
    <main className="c-main">
      <CContainer fluid>
        <Suspense fallback={<Loading />}>
          <Switch>
            {currentRoutes.map((route, idx) => route.component && (
            <Route
              key={idx}
              path={route.path}
              exact={route.exact}
              name={route.name}
              render={() => (
                <CFade>
                  {route.component}
                </CFade>
              )}
            />
            ))}
            <Redirect from="/" to="/dashboard" />
          </Switch>
        </Suspense>
      </CContainer>
    </main>
  );
};
export default React.memo(Content);
